import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/theusual.webp';
import screenshot_target from '../../../images/letterfunnel/marclaros.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Marc Laros"
      firstname="Marc"
      companyname="The Usual"
      competition="Conscious Hotels en The Social Hub"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marclaros.js